var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"","fixed":_vm.fixed,"placeholder":_vm.fplaceholder,"left-arrow":_vm.arrow},on:{"click-left":_vm.onBack},scopedSlots:_vm._u([(_vm.righticon)?{key:"right",fn:function(){return [_c('van-icon',{attrs:{"name":"ellipsis","size":23}})]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }